import React from 'react'
import { useTranslation } from 'react-i18next'

const UserGedcomStatusColumn = ({ file, warningStyle }) => {
  const { t } = useTranslation()

  return (
    <>
      {t(`user.gedcom.fileStatus.${file.fileStatus}`, file.fileStatus)}
      {file.fileStatus.toLowerCase() === 'processing' ? ` (${file.percentComplete}%)` : ''}
      <br />
      <div css={warningStyle}>{file.rejectReason}</div>
    </>
  )
}

export default UserGedcomStatusColumn
